<template>
  <div class="rule-widgets-option-wrapper">
    <b-form-group
      class="optimizer-form-group"
      label="Apply Rule To"
      :state="$_hasError('optionInput')"
      :invalid-feedback="$_getError('optionInput')"
    >
      <b-form-radio-group
        class="apply-rule-options"
        v-model="widget"
        :options="options"
        stacked
        name="optionInput"
        data-vv-as="Widgets option"
        v-validate="'required'"
      >
      </b-form-radio-group>
    </b-form-group>
  </div>
</template>

<script>
import component from '../mixins/component';

export default {
  name: 'RuleWidget',
  mixins: [component],
  props: {
    value: { type: [Boolean, null], default: null },
  },
  data() {
    return {
      widget: '',
      options: [
        { text: 'Apply to active widgets only', value: true },
        { text: 'Apply to all widgets (Paused widgets will be activated)', value: false },
      ],
    };
  },
  watch: {
    widget: {
      immediate: true,
      handler() {
        this.$_emit('widget');
      },
      deep: true,
    },
  },
  created() {
    this.widget = this.value;
  },
  methods: {
  },
};
</script>

<style lang="scss">
.rule-widgets-option-wrapper {
  margin-top: 2.5rem;

  .optimizer-form-group {
    margin-bottom: 0;

    .apply-rule-options {
      display: flex;

      .custom-control-input:checked {
        ~ .custom-control-label::before {
          background-color: $color-light-blue;
          border-color: $color-light-blue;
        }
      }

      .custom-control-label {
        margin-right: 2.5rem;
        font-size: 1.5rem;

        span {
          padding-left: .3rem;
        }

        &::before {
          top: .3rem;
          left: -1.9rem;
          width: 1.5rem;
          height: 1.5rem;
          box-shadow: none;
          outline: none;
        }

        &::after {
          top: 0.3rem;
          left: -1.9rem;
          width: 1.5rem;
          height: 1.5rem;
        }
      }
    }
  }
}
</style>
